import { resourceName } from "@Src/resources/applications_public/name";
import type { Resource } from "@Src/resources/resources_config";

// Backend-only resource for public analytics - no UI components
const resource: Resource = {
	name: resourceName.name,
	apiPath: "analytics_public/analytics_public",
	path: `/${resourceName.name}`,
};

export default resource;
